import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { Flex, Text } from '@mantine/core';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

export const PersonAddedAlert = ({ personName }: { personName: string }) => {
	const tCommonUi = useTranslationCommonUi();
	return (
		<Flex align="center" gap="0.25rem" maw="60%">
			<Icon variant="holdings-checkmark" size="md" />

			<Flex align="center" gap="0.25rem">
				<Text fz="sm" fw={400} truncate lineClamp={1}>
					{personName}
				</Text>
				<Text fz="sm" fw={400} c="dark.0" style={{ whiteSpace: 'nowrap' }}>
					{tCommonUi('added_to_list')}
				</Text>
			</Flex>
		</Flex>
	);
};
